import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


 

 
  
 

export default function Boxing_Home_Ar() {
    const jsonbasket = variables.basename_url +'updates/index/Athlethixnet_HomeAr_Boxing.json';
 
    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
 
    
    async function refda() {  
       
        //  To Show or Hidden Header And Footer
      document.getElementById('Arabic_Header').hidden = false;
      document.getElementById('Arabic_Footer').hidden = false;
      //

//
document.getElementById('Main_Dir').dir = "rtl";
  
//


      setNisLoading(true);


      Get_Data_Boxing_HOME_ar()
  
    };
   
    useEffect(() => {
      
       
        setNisLoading(true);
   
        refda();
           },[] )

   

 
           
           const [JsonArray, setJsonArray] = React.useState([]);
           async function Get_Data_Boxing_HOME_ar(){
         
            JsonArray.splice(0);  //to clear All data in your page
        
           setNisLoading(true);
        
           axios.get(jsonbasket)  
        
                 .then(function (response) {
                 setNisLoading( false);
        
                   console.log(response.data);
               
                  
             
        
                 for (let i = 0; i <1 && i < response.data.length; i++) {
                 
                    JsonArray.push({
                
                    news_title: response.data[i].news_title,
                    news_date:response.data[i].news_date.split(" ")[0],
                     news_imagename:response.data[i].Image  ,
                    link:response.data[i].link,
                    Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,
                    Category:response.data[i].Category,
                  
                  })
                  }
            })      
           }
             
 
         
             
 
     
            return (
          <>
 
 <div className="opinion-post mt-40">
{JsonArray.map(box=>   <div key= {box.news_title}  >  
        <div className="section-title">

          <a  href="Boxing_Ar"><h3 className="title float-right  mb-3">ملاكمه</h3></a>
           <br></br>
        </div>
        <div className="opinion-post-item">
           
  
   
        <div className="finance-thumb">
                   
                   <a  href={ box.link }>
                   <img className='BaskteImg rounded'     src={box.news_imagename} alt="gallery" />
                   </a>

                   <div class="finance-date">
                                         
                                       </div>

                 </div>
          <div className="opinion-post-content">
            <h3 className="title1 mt-4"><a href={ box.link}>{box.news_title}</a></h3>
            <a href={ box.link }> <p className='JUUSTIFY A-Color' >{parse(box.Description)}</p></a>
            <div className="meta-post-2-style"> 
              <div className="meta-post-categores">
                <a href={box.link}>{box.Category}</a>
              </div>
              <div className="meta-post-date">
                <span>{new Date(box.news_date).toLocaleDateString('ar-EG')}</span>
              </div>
            </div>
          </div>
        </div>
   
    
                   
          
        </div>
       
     )}
</div>
 
 
 
         </>
        );
    }


  
